'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _regenerator = require('babel-runtime/regenerator');
var _regenerator2 = _interopRequireDefault(_regenerator);
var _jsxFileName = 'src/new-business/stage3.js';
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _actions = require('@marmalade/form/lib/actions');
var _validation = require('@marmalade/form/lib/actions/validation');
var _form = require('@marmalade/form/lib/components/form');
var _form2 = _interopRequireDefault(_form);
var _formNavigation = require('@marmalade/form/lib/components/form-navigation');
var _formNavigation2 = _interopRequireDefault(_formNavigation);
var _input = require('@marmalade/form/lib/components/input');
var _input2 = _interopRequireDefault(_input);
var _introducerSelect = require('@marmalade/form/lib/components/introducer-select');
var _introducerSelect2 = _interopRequireDefault(_introducerSelect);
var _radio = require('@marmalade/form/lib/components/radio');
var _scrollToError = require('@marmalade/form/lib/components/scroll-to-error');
var _scrollToError2 = _interopRequireDefault(_scrollToError);
var _vehicleLookup = require('@marmalade/form/lib/components/vehicle-lookup');
var _vehicleLookup2 = _interopRequireDefault(_vehicleLookup);
var _email = require('@marmalade/form/lib/questions/email');
var _email2 = _interopRequireDefault(_email);
var _postcode = require('@marmalade/form/lib/questions/postcode');
var _postcode2 = _interopRequireDefault(_postcode);
var _vehicleInsurer = require('@marmalade/form/lib/questions/vehicle-insurer');
var _vehicleInsurer2 = _interopRequireDefault(_vehicleInsurer);
var _vehicleKept = require('@marmalade/form/lib/questions/vehicle-kept');
var _vehicleKept2 = _interopRequireDefault(_vehicleKept);
var _vehicleOwner = require('@marmalade/form/lib/questions/vehicle-owner');
var _vehicleOwner2 = _interopRequireDefault(_vehicleOwner);
var _vehiclePurchaseDate = require('@marmalade/form/lib/questions/vehicle-purchase-date');
var _vehiclePurchaseDate2 = _interopRequireDefault(_vehiclePurchaseDate);
var _fieldInfo = require('@marmalade/form/lib/selectors/field-info');
var _formInfo = require('@marmalade/form/lib/selectors/form-info');
var _introducerSelect3 = require('@marmalade/form/lib/selectors/introducer-select');
var _vehicleLookup3 = require('@marmalade/form/lib/selectors/vehicle-lookup');
var _grid = require('@marmalade/grid');
var _formOptions = require('@marmalade/marker-study/lib/form-options');
var _message = require('@marmalade/message');
var _message2 = _interopRequireDefault(_message);
var _panel = require('@marmalade/panel');
var _progressBar = require('@marmalade/progress-bar');
var _propTypes = require('@marmalade/prop-types');
var _glamorous = require('glamorous');
var _propTypes2 = require('prop-types');
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _reactRedux = require('react-redux');
var _reactRouterDom = require('react-router-dom');
var _guid = require('../guid');
var _guid2 = _interopRequireDefault(_guid);
var _renderIfBroker = require('../render-if-broker');
var _renderIfBroker2 = _interopRequireDefault(_renderIfBroker);
var _stage = require('../validation/new-business/stage3');
var _stage2 = _interopRequireDefault(_stage);
var _constants = require('./constants');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }
        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }
      return step("next");
    });
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var formId = _constants.stages[2].formId;
var NewStage3 = function (_Component) {
  _inherits(NewStage3, _Component);
  function NewStage3() {
    var _ref,
      _this2 = this;
    var _temp, _this, _ret;
    _classCallCheck(this, NewStage3);
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = NewStage3.__proto__ || Object.getPrototypeOf(NewStage3)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      showAll: _this.props.vehicleFound,
      error: ''
    }, _this.handleSubmit = function () {
      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee(formState) {
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!formState.validAndPristine) {
                  _context.next = 10;
                  break;
                }
                _context.prev = 1;
                _context.next = 4;
                return _this.props.serverSideValidation({
                  formId: formId,
                  validationUrl: _constants.validationUrl,
                  requiredStrings: _constants.stages[2].requiredStrings,
                  requiredDates: _constants.stages[2].requiredDates,
                  callback: function callback() {
                    _this.props.history.push(_this.props.linkPrefix + '/stage4');
                  }
                });
              case 4:
                _context.next = 10;
                break;
              case 6:
                _context.prev = 6;
                _context.t0 = _context['catch'](1);

                // Catch error from server to show as generic message
                _this.setState(Object.assign({}, _this.state, {
                  error: _context.t0.response.data.error.value
                }));
                window.scrollTo(0, 0);
              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[1, 6]]);
      }));
      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }(), _temp), _possibleConstructorReturn(_this, _ret);
  }
  _createClass(NewStage3, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (!this.props.vehicleFound && nextProps.vehicleFound) {
        this.setState(Object.assign({}, this.state, {
          showAll: true
        }));
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;
      var isWhitelabel = this.props.theme.name !== 'Marmalade';
      if (!this.props.stage2Complete) {
        return _react2.default.createElement(_reactRouterDom.Redirect, {
          to: this.props.linkPrefix + '/stage1',
          __source: {
            fileName: _jsxFileName,
            lineNumber: 111
          },
          __self: this
        });
      }
      var Element = this.props.container ? _grid.Container : _react.Fragment;
      return _react2.default.createElement(Element, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 115
        },
        __self: this
      }, _react2.default.createElement(_form2.default, {
        id: formId,
        product: 'ldi',
        handleSubmit: this.handleSubmit,
        validator: (0, _stage2.default)(this.props.keptOvernightOptions, this.props.relationOptions, this.props.regYear, {
          guid: this.props.guid,
          advertiserKeys: this.props.advertiserKeys,
          captureExtraAdvertiserData: this.props.captureExtraAdvertiserData,
          captureInstructor: this.props.captureInstructor
        }),
        preventSubmitOnEnterKey: true,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 116
        },
        __self: this
      }, _react2.default.createElement(_progressBar.WithStages, {
        newBusinessStages: _constants.stages,
        active: 3,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 133
        },
        __self: this
      }), _react2.default.createElement('h1', {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 134
        },
        __self: this
      }, _constants.stages[2].name), (this.props.hasErrors || this.state.error) && _react2.default.createElement(_message2.default, {
        type: 'error',
        __source: {
          fileName: _jsxFileName,
          lineNumber: 136
        },
        __self: this
      }, this.state.error ? this.state.error : 'There are some errors in the details you provided, please check them carefully and try\n                            again.'), _react2.default.createElement(_scrollToError2.default, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 143
        },
        __self: this
      }), _react2.default.createElement(_renderIfBroker2.default, {
        checkboxName: 'broker_stage_3a',
        options: [{
          text: 'They do not own the car.',
          value: 'true'
        }, {
          text: 'A MID check will be carried out to make sure that a main insurance policy is in place.',
          value: 'true'
        }],
        __source: {
          fileName: _jsxFileName,
          lineNumber: 144
        },
        __self: this
      }, _react2.default.createElement('p', {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 157
        },
        __self: this
      }, 'Marmalade insures young people to learn to drive in someone else car, normally a parent. The car must already have insurance covering it.'), _react2.default.createElement('p', {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 161
        },
        __self: this
      }, 'Please confirm with the customer that:')), _react2.default.createElement(_panel.PanelAside, {
        title: '',
        __source: {
          fileName: _jsxFileName,
          lineNumber: 164
        },
        __self: this
      }, this.props.hasQPlate && _react2.default.createElement(_message2.default, {
        type: 'error',
        __source: {
          fileName: _jsxFileName,
          lineNumber: 166
        },
        __self: this
      }, 'Unfortunately, because you have a Q-plated car we cannot insure you.'), _react2.default.createElement(_vehicleLookup2.default, {
        disableManualLookup: true,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 170
        },
        __self: this
      }), this.state.showAll && _react2.default.createElement('div', {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 172
        },
        __self: this
      }, _react2.default.createElement(_vehiclePurchaseDate2.default, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 173
        },
        __self: this
      }), _react2.default.createElement(_vehicleInsurer2.default, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 174
        },
        __self: this
      }), _react2.default.createElement(_postcode2.default, {
        vehicleKept: true,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 175
        },
        __self: this
      }), _react2.default.createElement(_vehicleKept2.default, {
        options: this.props.keptOvernightOptions,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 176
        },
        __self: this
      }))), this.state.showAll && _react2.default.createElement(_react.Fragment, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 181
        },
        __self: this
      }, _react2.default.createElement(_panel.PanelAside, {
        title: 'Car owner details',
        __source: {
          fileName: _jsxFileName,
          lineNumber: 182
        },
        __self: this
      }, _react2.default.createElement(_vehicleOwner2.default, {
        label: 'Car owner\'s name',
        relationOptions: this.props.relationOptions,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 183
        },
        __self: this
      }), _react2.default.createElement(_email2.default, {
        name: 'ownerEmail',
        label: "Car owner\u2019s email",
        placeholder: '',
        helpText: "We request the car owner\u2019s email to notify them of a policy on their vehicle. We also intend contacting them to offer the option of receiving marketing updates. Refer to " + (isWhitelabel ? "Marmalade's" : 'our') + ' Privacy Policy for further information.',
        __source: {
          fileName: _jsxFileName,
          lineNumber: 184
        },
        __self: this
      }), _react2.default.createElement(_radio.RadioYesNo, {
        name: 'vehicleOwnerPermission',
        label: 'Would you like to grant permission for the car owner to pay for, renew or amend the insurance policy?',
        helpText: 'If you select yes, the car owner will receive notifications by email before the policy is due to expire.',
        onChange: function onChange(value) {
          if (value === 'Y') {
            _this3.props.resetFields(formId, ['thirdPartyPermission', 'thirdPartyName', 'thirdPartyEmail']);
          }
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 192
        },
        __self: this
      }), this.props.denyVehicleOwnerPermission && _react2.default.createElement(_react.Fragment, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 207
        },
        __self: this
      }, _react2.default.createElement(_radio.RadioYesNo, {
        name: 'thirdPartyPermission',
        label: 'Would you like to grant permission for someone else to pay for, renew or amend the insurance policy?',
        helpText: 'If you select yes, this person will receive a copy of your quotation and notifications by email before the policy is due to expire.',
        onChange: function onChange(value) {
          if (value === 'N') {
            _this3.props.resetFields(formId, ['thirdPartyName', 'thirdPartyEmail']);
          }
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 208
        },
        __self: this
      }), this.props.hasThirdPartyPermission && _react2.default.createElement(_react.Fragment, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 222
        },
        __self: this
      }, _react2.default.createElement(_input2.default, {
        name: 'thirdPartyName',
        label: 'Please let us know their name',
        __source: {
          fileName: _jsxFileName,
          lineNumber: 223
        },
        __self: this
      }), _react2.default.createElement(_email2.default, {
        name: 'thirdPartyEmail',
        label: 'Please let us know their email',
        placeholder: '',
        __source: {
          fileName: _jsxFileName,
          lineNumber: 224
        },
        __self: this
      })))), this.props.guid ? null : _react2.default.createElement(_panel.PanelAside, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 236
        },
        __self: this
      }, _react2.default.createElement(_introducerSelect2.default, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 237
        },
        __self: this
      }))), _react2.default.createElement(_formNavigation2.default, {
        next: {
          submit: true,
          disabled: this.props.hasQPlate,
          text: 'Proceed to Step 4',
          posting: this.props.posting
        },
        prev: {
          text: 'Back',
          link: this.props.linkPrefix + '/stage2'
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 242
        },
        __self: this
      })));
    }
  }]);
  return NewStage3;
}(_react.Component);
NewStage3.propTypes = {
  linkPrefix: _propTypes2.string.isRequired,
  history: _propTypes.history.isRequired,
  vehicleFound: _propTypes2.bool.isRequired,
  stage2Complete: _propTypes2.bool.isRequired,
  posting: _propTypes2.bool.isRequired,
  serverSideValidation: _propTypes2.func.isRequired,
  manufacturedFromYear: _propTypes2.number,
  regYear: _propTypes2.number,
  keptOvernightOptions: _propTypes2.array.isRequired,
  relationOptions: _propTypes2.array.isRequired,
  container: _propTypes2.bool.isRequired,
  hasQPlate: _propTypes2.bool,
  denyVehicleOwnerPermission: _propTypes2.bool.isRequired,
  hasThirdPartyPermission: _propTypes2.bool.isRequired,
  hasErrors: _propTypes2.bool.isRequired,
  advertiserKeys: _propTypes2.array.isRequired,
  guid: _propTypes2.string,
  captureExtraAdvertiserData: _propTypes2.bool.isRequired,
  captureInstructor: _propTypes2.bool.isRequired
};
NewStage3.defaultProps = {
  manufacturedFromYear: undefined,
  regYear: undefined,
  hasQPlate: false
};
exports.default = (0, _reactRouterDom.withRouter)((0, _glamorous.withTheme)((0, _reactRedux.connect)(function (state, ownProps) {
  return {
    stage2Complete: (0, _formInfo.isValidAndPristine)(state, _constants.stages[1].formId),
    posting: (0, _formInfo.isSubmittingForm)(state, formId),
    vehicleFound: !!(0, _fieldInfo.getValue)(state, formId, 'abiCode'),
    denyVehicleOwnerPermission: (0, _fieldInfo.getValue)(state, formId, 'vehicleOwnerPermission') === 'N',
    hasThirdPartyPermission: (0, _fieldInfo.getValue)(state, formId, 'thirdPartyPermission') === 'Y',
    hasQPlate: /^Q/i.test((0, _fieldInfo.getValue)(state, formId, 'regNo')),
    manufacturedFromYear: (0, _vehicleLookup3.manufacturedFromYear)(state, formId),
    regYear: (0, _vehicleLookup3.regYear)(state, formId),
    keptOvernightOptions: (0, _formOptions.options)(state).keptOvernight || [],
    relationOptions: (0, _formOptions.options)(state).ownerRelation || [],
    advertiserKeys: (0, _introducerSelect3.advertiserKeys)(formId)(state),
    guid: (0, _guid2.default)(state, ownProps.theme),
    captureExtraAdvertiserData: (0, _introducerSelect3.captureExtraAdvertiserData)(formId)(state),
    captureInstructor: (0, _introducerSelect3.captureInstructor)(formId)(state),
    hasErrors: (0, _formInfo.hasErrors)(state, formId)
  };
}, {
  serverSideValidation: _validation.serverSideValidation,
  resetFields: _actions.resetFields
})(NewStage3)));